<script>
  import {couponHistory} from "@/api/coupon";

  export default {
    props: [ 'searchParams'],
    data(){
      return{
        tableList: [],
        loading: true,
        total:0,
        page:1
      }
    },
    mounted() {
      this.getUsageLog(this.searchParams)
    },
    methods: {
      getUsageLog(param) {
        this.loading = true
        couponHistory({limit: 10, page: this.page, ...param}).then(res => {
          this.loading = false
          if (res.code === 200){
            this.tableList = res.data.list;
            this.total = res.data.total;
          } else {
            this.loading = false
          }
        })
      },
      pageHandler(val){
        this.page = val;
        this.getUsageLog();
      }
    }
  }
</script>

<template>
  <div v-loading="loading">
    <div v-if="tableList.length > 0">
      <el-table :data="tableList" stripe class="tailwind" style="width: 100%">
        <el-table-column prop="coupon_no" label="Coupon No." align="center" />
        <el-table-column prop="coupon_name" label="Coupon Name" align="center" />
        <el-table-column prop="amount_deducted" label="Amount deducted" align="center"/>
        <el-table-column prop="amount_paid" label="Amount paid" align="center" />
        <el-table-column prop="applied_order_no" label="Applied Order No." align="center"/>
        <el-table-column prop="coupon_user" label="Coupon user" align="center"/>
        <el-table-column prop="coupon_uid" label="Coupon UID" align="center"/>
        <el-table-column prop="usage_time" label="Usage time" align="center"/>
      </el-table>
    </div>
    <table-empty v-else></table-empty>
    <ra-pagination
      :currentPage="page"
      :list-length="tableList.length"
      @pageChange="pageHandler"
      :total="total"
    ></ra-pagination>
  </div>
</template>

<style scoped lang="less">

</style>
